export default __webpack_public_path__ + "static/blob13-912c383aca93ebb0527142eb0a5e0668.svg";